import { API_BASE_URL, authFetch } from './api';


// === Types ===

export interface ApiKey {
  id: string;
  name: string;
  last4: string;
  revoked: boolean;
  last_used_at: string | null;
  expires_at: string | null;
  revoked_at: string | null;
  created_at: string;
}

export interface ApiKeyCreated extends ApiKey {
  token: string;
}

// === API Functions ===

const BASE = `${API_BASE_URL}/api-keys`;

export async function listApiKeys(): Promise<ApiKey[]> {
  const res = await authFetch(BASE);
  return res.json();
}

export async function createApiKey(
  name: string,
  expiresAt?: string | null
): Promise<ApiKeyCreated> {
  const res = await authFetch(BASE, {
    method: 'POST',
    body: JSON.stringify({ name, ...(expiresAt ? { expires_at: expiresAt } : {}) }),
  });
  return res.json();
}

export async function revokeApiKey(id: string): Promise<ApiKey> {
  const res = await authFetch(`${BASE}/${id}`, { method: 'DELETE' });
  return res.json();
}

export async function revokeAllApiKeys(): Promise<{ success: boolean; revoked: number }> {
  const res = await authFetch(`${BASE}/revoke-all`, { method: 'POST' });
  return res.json();
}
